<template>
    <div>
        <div v-if="!form.address">Getting address....</div>
        <v-card v-else>
            <v-toolbar flat>
                <v-toolbar-title>
                    {{ form.address.address_type.desc }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn :href="mapLink"
                       target="_blank"
                       color="blue"
                       small
                       flat
                       rounded
                       outlined
                       icon
                >
                    <v-icon>map</v-icon>
                </v-btn>
                <v-btn color="orange"
                       small
                       flat
                       rounded
                       outlined
                       icon
                       @click="readOnly = !readOnly"
                >
                    <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                        @click="remove()"
                        color="red"
                       small
                       flat
                       rounded
                       outlined
                       icon
                >
                    <v-icon>delete</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-text-field
                                label="Street"
                                box
                                v-model="form.address.street"
                                :readonly="readOnly"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field
                                label="City"
                                box
                                v-model="form.address.city"
                                :readonly="readOnly"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs8>
                        <v-text-field
                                label="State"
                                box
                                v-model="form.address.state"
                                :readonly="readOnly"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field
                                label="Zipcode"
                                box
                                v-model="form.address.zipcode"
                                :readonly="readOnly"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <v-text-field
                                label="County"
                                box
                                v-model="form.address.county"
                                :readonly="readOnly"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <v-text-field
                                label="Region"
                                box
                                v-model="form.address.region_type.desc"
                                :readonly="readOnly"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <v-text-field
                                label="Lat"
                                box
                                v-model="form.address.lat"
                                :readonly="readOnly"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <v-text-field
                                label="Lon"
                                box
                                v-model="form.address.lon"
                                :readonly="readOnly"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions v-if="!readOnly">
                <v-btn flat outlined rounded color="green" @click="saveAddress()" :loading="controls.loading">Save</v-btn>
                <v-btn flat outlined rounded color="orange" @click="cancel()">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
    import belit from '../Lib/Belit';
    export default {
        name: "DirectoryAddressCard",
        data () {
            return {
                readOnly: true,
                controls:{
                    loading: false,
                },
                form:{
                    address: null
                },
            }
        },
        props: {
            address: {
                type: Object,
                required: true
            },
        },
        computed: {
            mapLink () {
                return 'https://www.google.com/maps/search/?api=1&query='+this.form.address.lat+','+this.form.address.lon
            }
        },
        watch:{
          address(){
              this.buildAddress();
          }
        },
        created(){
            this.buildAddress()
        },
        methods:{
            buildAddress(){
                this.form.address = this.address;
            },
            async saveAddress(){
                this.controls.loading = true;
                try{
                    await this.$store.$db().model('addresses').api().save(this.form.address);
                    this.$store.dispatch('showSuccess', "Saved address.")
                }catch(error){
                    this.$store.dispatch('showError', error)
                }
                this.readOnly = true;
                this.controls.loading = false;
            },
            async remove(){
                return;
                try{
                    await this.$store.$db().model('addresses').api().save('/addresses/delete', {
                        id: this.form.address.id
                    })
                    this.cancel();
                    this.$store.dispatch("showSuccess", "Deleted address")
                }catch(error){
                    this.$store.dispatch("showError", error)
                }
            },
            cancel(){
                this.readOnly = true;
                this.$emit('reload');
            }
        }
    }
</script>

<style scoped>

</style>
